import { platformFetch } from "services/platformFetch";
import { auth } from "services/firebase";
export const getMyPublicationOrders = async ({
  authId,
  page = 1,
  limit = 20,
  search = "",
  payment = "all",
  refreshSaved = false,
  sync = false,
  signal,
}) => {
  const params = new URLSearchParams({
    authId,
    page: String(page),
    limit: String(limit),
    search,
    payment,
  });

  if (refreshSaved) {
    params.set("refreshSaved", "1");
  }

  if (sync) {
    params.set("sync", "1");
  }

  if (!auth?.currentUser) throw new Error("Entre na sua conta para continuar.");
  const response = await platformFetch(`/api/tray/orders?${params.toString()}`, {
    headers: { Authorization: `Bearer ${await auth.currentUser.getIdToken()}` },
    signal,
  });
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    const details = body?.details ? ` Detalhes: ${JSON.stringify(body.details)}` : "";
    throw new Error(`${body?.message || "Nao foi possivel consultar seus pedidos."}${details}`);
  }

  return body;
};
